import React from "react";
import UnorderedList from "../MenuItems/UnorderedList";
import OrderedList from "../MenuItems/UnorderedList";

const Lists = ({ editor, disabled }) => {
	return (
		<>
			<div className={`editor-menu-box`}>
				<UnorderedList
					onClick={() => editor.chain().focus().toggleBulletList().run()}
					isActive={editor.isActive("bulletList")}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleBulletList().run()
					}
				/>
				<OrderedList
					onClick={() => editor.chain().focus().toggleOrderedList().run()}
					isActive={editor.isActive("orderedList")}
					isDisabled={
						disabled || !editor.can().chain().focus().toggleOrderedList().run()
					}
				/>
			</div>
			<style>{`
            `}</style>
		</>
	);
};

export default Lists;
